export const AlertIcon = ({ className }: { className?: string }) => {
  return (
    <svg
      width="64"
      height="64"
      viewBox="0 0 64 64"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M31.9977 3.74219C16.3915 3.74219 3.74023 16.3935 3.74023 31.9996C3.74023 47.6056 16.3915 60.257 31.9977 60.257C47.6037 60.257 60.2551 47.6056 60.2551 31.9996C60.2551 16.3935 47.6037 3.74219 31.9977 3.74219ZM7.79357 31.9996C7.79357 18.6321 18.6301 7.79552 31.9977 7.79552C45.3651 7.79552 56.2017 18.6321 56.2017 31.9996C56.2017 45.367 45.3651 56.2037 31.9977 56.2037C18.6301 56.2037 7.79357 45.367 7.79357 31.9996ZM32.0002 35.2001C30.822 35.2001 29.8669 34.245 29.8669 33.0668V20.2668C29.8669 19.0886 30.822 18.1334 32.0002 18.1334C33.1784 18.1334 34.1336 19.0886 34.1336 20.2668V33.0668C34.1336 34.245 33.1784 35.2001 32.0002 35.2001ZM28.8002 41.6001C28.8002 39.8328 30.2329 38.4001 32.0002 38.4001C33.7675 38.4001 35.2002 39.8328 35.2002 41.6001C35.2002 43.3674 33.7675 44.8001 32.0002 44.8001C30.2329 44.8001 28.8002 43.3674 28.8002 41.6001Z"
        fill="currentColor"
      />
    </svg>
  )
}
